import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule, DropdownModule, TooltipModule } from '@xref/xref-lib';
import { PackageApiSettingsModalComponent } from './package-api-settings-modal.component';

@NgModule({
  declarations: [PackageApiSettingsModalComponent],
  imports: [CommonModule, FormsModule, ButtonModule, DropdownModule, TooltipModule],
  exports: [PackageApiSettingsModalComponent],
})
export class PackageApiSettingsModalModule {}
